<template>
  <v-main>
    <div :class="CSSclass">
      <v-row v-if="gridType === 'sides'">
        <v-col cols="12">
          <slot name="topSection"></slot>
        </v-col>
        <v-col cols="12" md="3">
          <slot name="sideSection"></slot>
        </v-col>
        <v-col cols="12" md="9">
          <slot name="contentSection"></slot>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <slot name="headerInfo"></slot>
        </v-col>
        <v-col cols="12">
          <slot name="singleSection"></slot>
        </v-col>
      </v-row>
    </div>
    <slot name="additionalSpace"></slot> 
  </v-main>
</template>

<script>
export default {
  name: "Page",
  props: ["gridType"],
  computed: {
    CSSclass() {
      if (this.gridType === "full" || this.gridType === "sides") {
        return "full-screen-grid";
      } else if (this.gridType === "centered") {
        return "centered-screen-grid";
      } else {
        return "full-screen-grid";
      }
    },
  },
};
</script>
